import posthog from 'posthog-js'

export const initPostHog = () => {
  if (typeof window !== 'undefined') {
    posthog.init(process.env.REACT_APP_POSTHOG_KEY || 'phc_YOUR_PROJECT_API_KEY', {
      api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://app.posthog.com',
      capture_pageview: false, // We'll handle this manually for better control
      capture_pageleave: true,
      persistence: 'localStorage',
      autocapture: true,
      session_recording: {
        enabled: true,
        sample_rate: 0.1, // Record 10% of sessions
      },
    })
  }
  return posthog
}

export default posthog